export const getGeneralNextPage = (
	length: number,
	page?: number,
) => {
	const next = (page ?? 0) + length

	if (page === undefined) return length
	if (length) return next

	return undefined
}
export const flattenAndFilterArrays = <T, K, L>(
	pages: T[],
	extractor: (data: T) => K[],
	identity: (data: K) => L,
): K[] => {
	const dataSet = new Set()
	const filteredArray = new Array<K>()

	for (const page of pages) {
		for (const data of extractor(page)) {
			if (!dataSet.has(identity(data))) {
				dataSet.add(identity(data))
				filteredArray.push(data)
			}
		}
	}

	return filteredArray
}
